// Landing-page strip showing real Imagen-generated supporters with their
// AI-spoken messages. Communicates the v2 product (each tipper gets a unique
// AI character + voice) without needing the backend wired up live yet.

// Imagen 4 Ultra only.
const CAST = [
  { slug: "aria",  name: "Aria",  amt: 25,  msg: "watching from the deep blue, friend", voiceLabel: "Bella · calm" },
  { slug: "boris", name: "Boris", amt: 100, msg: "for the realm! charge!", voiceLabel: "Arnold · gruff" },
  { slug: "cosma", name: "Cosma", amt: 5,   msg: "leaving a trail of stardust on your wall", voiceLabel: "River · androgynous" },
  { slug: "drako", name: "Drako", amt: 50,  msg: "this coffee is the only reason I'm awake", voiceLabel: "Brian · deep" },
  { slug: "eevy",  name: "Eevy",  amt: 10,  msg: "the forest sends its regards", voiceLabel: "Matilda · warm" },
  { slug: "fynn",  name: "Fynn",  amt: 20,  msg: "stay sharp out there", voiceLabel: "Daniel · british" },
  { slug: "gala",  name: "Gala",  amt: 5,   msg: "haunting your wall in cute mode", voiceLabel: "Lily · british" },
];

export default function AiCastShowcase(): JSX.Element {
  return (
    <section className="lp-section ai-cast-section">
      <div className="lp-section-head">
        <div className="lp-eyebrow">Meet the cast</div>
        <h2>
          Every supporter gets <span className="lp-grad">their own face and voice.</span>
        </h2>
        <p style={{ maxWidth: 720, opacity: 0.78, marginTop: 12, fontSize: 16, lineHeight: 1.6 }}>
          The next SubsWall release generates a unique character for each
          tipper using Imagen, gives them their own permanent voice, and
          reads their message aloud on your stream. Here are 7 real
          AI-generated supporters as a preview.
        </p>
      </div>
      <div className="ai-cast-grid">
        {CAST.map((c) => (
          <div key={c.slug} className="ai-cast-card">
            <div className="ai-cast-img-wrap">
              <img
                src={`/overlay-demo/ai-chars/${c.slug}.png`}
                alt={c.name}
                width={256}
                height={256}
                loading="lazy"
              />
              <div className="ai-cast-badge">⌬ AI</div>
            </div>
            <div className="ai-cast-meta">
              <div className="ai-cast-header">
                <span className="ai-cast-name">{c.name}</span>
                <span className="ai-cast-amt">${c.amt}</span>
              </div>
              <div className="ai-cast-msg">"{c.msg}"</div>
              <div className="ai-cast-voice">
                <span className="ai-cast-voice-icon">▸</span>
                {c.voiceLabel}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
